import { defineComponent as _defineComponent } from 'vue'
import BubbleMenu from '@/components/basics/BubbleMenu.vue';
import { LicenseFeature, Role } from '@/modules/shared/types';
import { CompanyRepresentation, UserRepresentation } from '@/clients/dashboardapi/v2';
import { Port } from '@/modules/shared/Port';
import LicenseGuard from '@/modules/shared/components/util/LicenseGuard.vue';
import RoleGuard from '@/modules/shared/components/util/RoleGuard.vue';
import { onMounted, ref, computed } from 'vue';
import store from '@/store/store';
import { i18n, I18nAdapter } from '@/plugins/i18n';

type Props = {
    anchor: HTMLElement|null;
}
type Emits = {
    (e: 'close'): void;
    (e: 'license-error', feature: LicenseFeature): void;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'MenuUser',
  props: {
    anchor: null
  },
  emits: ["close", "license-error"],
  setup(__props: any, { emit: emits }: { emit: ({
    (e: 'close'): void;
    (e: 'license-error', feature: LicenseFeature): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
    anchor: HTMLElement|null;
};





const user = ref<UserRepresentation|null>(null);
const accountPage = ref<string>('');
const userCompany = ref<CompanyRepresentation|null>(null);
const isAppAdmin = ref<boolean>(false);

function resetOnboarding() {
    store.commit('App/setOnboardingProgress', { progress: 0 });
    close();
}

function loadLanguage(lang: string) {
    I18nAdapter.changeLanguage(lang);
    close();
}

function close() {
    emits('close');
}

const routeToAdmin = computed(() => {
    if (isAppAdmin.value) {
        return { name: 'admin-customers' };
    }
    return store.getters['User/hasFeatureLicense'](LicenseFeature.REIMPORT) ? { name: 'data-imports' } : { name: 'ctx-admin-functions' };
});

async function fetchUser(): Promise<void> {
    user.value = await Port.auth.getUser();
    accountPage.value = await Port.auth.getAccountSettingsUrl(i18n.locale);
}

async function fetchUserCompany(): Promise<void> {
    userCompany.value = await Port.auth.getCompany();
}

onMounted(async () => {
    await fetchUser();
    await fetchUserCompany();
    isAppAdmin.value = await Port.auth.isAppAdmin();
});

return { __sfc: true,props, emits, user, accountPage, userCompany, isAppAdmin, resetOnboarding, loadLanguage, close, routeToAdmin, fetchUser, fetchUserCompany, BubbleMenu, LicenseFeature, Role, LicenseGuard, RoleGuard }
}

})